// 品牌/装饰图标已拆至 brand-icons.tsx（保留同路径 re-export 以兼容历史调用方）
export {
  IosIcon,
  AndroidIcon,
  GooglePlayIcon,
  DogLogo,
  PointIcon,
  RewardPlanIcon,
  PolymarketIcon,
  ShareScore,
  LiveScore,
  UserScore,
  AppStoreIcon,
  WindowsIcon
} from './icons/brand-icons';

// switch切换；size 为图形像素边长（默认 54，与 viewBox 一致）
export const SwitchIcon = ({
  className = '',
  size = 54,
  ...props
}: {
  className?: string;
  /** 图标边长（px） */
  size?: number;
  [key: string]: any;
}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
      <path d="M54 27C54 41.9117 41.9117 54 27 54C12.0883 54 0 41.9117 0 27C0 12.0883 12.0883 0 27 0C41.9117 0 54 12.0883 54 27Z" fill="currentColor" />
      <path
        d="M27 6.13599C38.5227 6.13599 47.8643 15.4766 47.8643 26.9993C47.8643 38.5219 38.5227 47.8625 27 47.8625C15.4775 47.8624 6.13672 38.5218 6.13672 26.9993C6.13672 15.4767 15.4775 6.13618 27 6.13599ZM23.918 17.4543C23.7638 17.4543 23.6102 17.4842 23.4678 17.5432C23.3256 17.6021 23.1968 17.6894 23.0879 17.7981C22.979 17.907 22.892 18.0367 22.833 18.179C22.7741 18.3212 22.7433 18.4742 22.7432 18.6282V29.2327C22.7342 29.2898 22.7064 29.3438 22.6631 29.3821C22.6198 29.4201 22.5634 29.4408 22.5059 29.4426H19.6221C19.4009 29.4428 19.1838 29.5036 18.9941 29.6174C18.8044 29.7316 18.6479 29.8956 18.5439 30.0911C18.4425 30.2903 18.3972 30.5145 18.4121 30.7375C18.4272 30.9609 18.5015 31.1775 18.6289 31.3616L22.8867 36.0286C23.0337 36.2398 23.2445 36.4002 23.4883 36.4827C23.7322 36.5651 23.997 36.5664 24.2422 36.4875C24.4889 36.4086 24.7047 36.2534 24.8574 36.0442C25.0099 35.8352 25.0918 35.5822 25.0918 35.3235V18.6282C25.0917 18.4743 25.0618 18.3211 25.0029 18.179C24.9439 18.0367 24.857 17.907 24.748 17.7981C24.6391 17.6892 24.5095 17.6022 24.3672 17.5432C24.2249 17.4843 24.0719 17.4544 23.918 17.4543ZM30.5127 17.5276C30.2688 17.4451 30.0039 17.442 29.7588 17.5208C29.5137 17.5992 29.3009 17.7549 29.1484 17.9622C28.9962 18.1692 28.9104 18.4181 28.9082 18.675V35.3704C28.9083 35.6814 29.0331 35.9804 29.2529 36.2004C29.473 36.4205 29.7719 36.545 30.083 36.5452C30.3942 36.5452 30.693 36.4204 30.9131 36.2004C31.1331 35.9804 31.2577 35.6815 31.2578 35.3704L31.2109 24.7668C31.2199 24.7096 31.2476 24.6557 31.291 24.6174C31.3342 24.5795 31.3898 24.5587 31.4473 24.5569H34.3779C34.5996 24.5568 34.8188 24.4964 35.0088 24.3821C35.1982 24.268 35.3522 24.1036 35.4561 23.9084C35.5575 23.7092 35.6037 23.485 35.5889 23.262C35.5737 23.0385 35.4987 22.8211 35.3711 22.637L31.1143 17.9797C30.9673 17.7685 30.7564 17.6101 30.5127 17.5276Z"
        fill="#33FF00"
      />
    </svg>
  );
};
// 文件上传
export const FileUploadIcon = ({ className = '', ...props }: { className?: string; [key: string]: any }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      role="img"
      className={className}
      {...props}
    >
      <path
        fill="currentColor"
        d="M13.82 21.7c.17.05.14.3-.04.3H6a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4h7.5c.28 0 .5.22.5.5V5a5 5 0 0 0 5 5h2.5c.28 0 .5.22.5.5v2.3a.4.4 0 0 1-.68.27l-.2-.2a3 3 0 0 0-4.24 0l-4 4a3 3 0 0 0 0 4.25c.3.3.6.46.94.58Z"
      />
      <path
        fill="currentColor"
        d="M21.66 8c.03 0 .05-.03.04-.06a3 3 0 0 0-.58-.82l-4.24-4.24a3 3 0 0 0-.82-.58.04.04 0 0 0-.06.04V5a3 3 0 0 0 3 3h2.66Z"
      />
      <path
        fill="currentColor"
        d="M18.3 14.3a1 1 0 0 1 1.4 0l4 4a1 1 0 0 1-1.4 1.4L20 17.42V23a1 1 0 1 1-2 0v-5.59l-2.3 2.3a1 1 0 0 1-1.4-1.42l4-4Z"
      />
    </svg>
  );
};
// 连麦
export const CoGuestIcon = ({ className = '', ...props }: { className?: string; [key: string]: any }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
      <path
        d="M2.30341 10.0236C1.80818 8.59092 2.43509 7.05223 3.65436 6.15121C4.57874 5.46811 5.5073 4.77823 6.03717 4.38414C6.28895 4.19687 6.64191 4.23783 6.84516 4.47688L9.73259 7.87286C9.92137 8.09489 9.92146 8.42094 9.73281 8.64308L7.96229 10.7278C7.80112 10.9176 7.77428 11.1883 7.9017 11.4022C8.47537 12.3652 9.10487 13.19 9.95554 14.0404C10.8112 14.8958 11.6359 15.5131 12.6043 16.0853C12.8184 16.2118 13.0887 16.1849 13.2783 16.0241L15.3545 14.2629C15.5767 14.0744 15.9028 14.0746 16.1248 14.2632L19.5236 17.1514C19.762 17.354 19.8028 17.7065 19.6168 17.9581L17.8389 20.3633C16.945 21.5725 15.4183 22.1874 13.9961 21.6981C11.3673 20.7936 8.89828 19.2926 6.80005 17.195C4.70783 15.1034 3.20895 12.6432 2.30341 10.0236Z"
        stroke="currentColor"
        strokeOpacity="0.9"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.1077 3.96667L21.4245 4.64646L21.4248 4.64631L21.1077 3.96667ZM21.8665 4.45007H21.1165H21.8665ZM21.8665 8.5448L22.6165 8.54528V8.5448H21.8665ZM21.1077 9.0282L20.7902 9.70769L20.7905 9.70785L21.1077 9.0282ZM13.3333 9.79382L13.3331 10.5438H13.3333V9.79382ZM12.8 3.73328L12.05 3.7331V3.73328H12.8ZM13.3333 3.20007V2.45007H13.3331L13.3333 3.20007ZM20.3299 8.66478L20.6473 7.98529L20.3299 8.66478ZM20.3294 4.32943L20.0125 3.64964L20.3294 4.32943ZM18.8606 3.20007V3.95007C18.7407 3.95007 18.6438 3.85286 18.6438 3.73346L19.3938 3.73328L20.1438 3.7331C20.1436 3.02471 19.5695 2.45007 18.8606 2.45007V3.20007ZM20.3294 4.32943L20.6462 5.00921L21.4245 4.64646L21.1077 3.96667L20.7908 3.28689L20.0125 3.64964L20.3294 4.32943ZM21.1077 3.96667L21.4248 4.64631C21.2809 4.71349 21.1165 4.60824 21.1165 4.45007H21.8665H22.6165C22.6165 3.51151 21.6416 2.88984 20.7905 3.28704L21.1077 3.96667ZM21.8665 4.45007H21.1165V8.5448H21.8665H22.6165V4.45007H21.8665ZM21.8665 8.5448L21.1165 8.54432C21.1166 8.38695 21.2802 8.28108 21.4248 8.34854L21.1077 9.0282L20.7905 9.70785C21.6421 10.1052 22.6159 9.48262 22.6165 8.54528L21.8665 8.5448ZM21.1077 9.0282L21.4251 8.34871L20.6473 7.98529L20.3299 8.66478L20.0124 9.34427L20.7902 9.70769L21.1077 9.0282ZM19.3938 9.26062H18.6438C18.6438 9.14096 18.7409 9.04382 18.8606 9.04382V9.79382V10.5438C19.5694 10.5438 20.1438 9.96939 20.1438 9.26062H19.3938ZM18.8606 9.79382V9.04382H13.3333V9.79382V10.5438H18.8606V9.79382ZM13.3333 9.79382L13.3334 9.04382C13.4528 9.04385 13.55 9.14074 13.55 9.26062H12.8H12.05C12.05 9.96952 12.6247 10.5437 13.3331 10.5438L13.3333 9.79382ZM12.8 9.26062H13.55V3.73328H12.8H12.05V9.26062H12.8ZM12.8 3.73328L13.55 3.73345C13.55 3.85308 13.4531 3.95004 13.3334 3.95007L13.3333 3.20007L13.3331 2.45007C12.6246 2.45024 12.0502 3.02457 12.05 3.7331L12.8 3.73328ZM13.3333 3.20007V3.95007H18.8606V3.20007V2.45007H13.3333V3.20007ZM20.3299 8.66478L20.6473 7.98529C19.714 7.54921 18.6438 8.23046 18.6438 9.26062H19.3938H20.1438C20.1438 9.32819 20.0736 9.37287 20.0124 9.34427L20.3299 8.66478ZM19.3938 3.73328H18.6438C18.6438 4.76291 19.713 5.44419 20.6462 5.00921L20.3294 4.32943L20.0125 3.64964C20.0737 3.62113 20.1438 3.66579 20.1438 3.73328H19.3938Z"
        fill="currentColor"
        fillOpacity="0.9"
      />
    </svg>
  );
};
// 空态
// Empty Icon - 空状态图标（Inbox 收件箱样式）
export const EmptyIcon = ({ className = '', ...props }: { className?: string; [key: string]: any }) => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
      <path
        d="M22 13.5H17C15.6 13.5 14.5 14.6 14.5 16C14.5 17.1 13.6 18 12.5 18H11.5C10.4 18 9.5 17.1 9.5 16C9.5 14.6 8.4 13.5 7 13.5H2"
        stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
      />
      <path
        d="M5.45 5.11L2 12V16C2 18.21 3.79 20 6 20H18C20.21 20 22 18.21 22 16V12L18.55 5.11C18.21 4.43 17.51 4 16.75 4H7.25C6.49 4 5.79 4.43 5.45 5.11Z"
        stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
      />
    </svg>
  );
};
// 复制icon
export const CopyIcon = ({ className = '', ...props }: { className?: string; [key: string]: any }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" className={className} {...props}>
      <path
        d="M6.5 6.22V3.91C6.5 3.13 7.13 2.5 7.91 2.5H20.09C20.87 2.5 21.5 3.13 21.5 3.91V16.09C21.5 16.87 20.87 17.5 20.09 17.5H17.76"
        stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
      />
      <path
        d="M16.09 6.5H3.91C3.13 6.5 2.5 7.13 2.5 7.91V20.09C2.5 20.87 3.13 21.5 3.91 21.5H16.09C16.87 21.5 17.5 20.87 17.5 20.09V7.91C17.5 7.13 16.87 6.5 16.09 6.5Z"
        fill="currentColor" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"
      />
    </svg>
  );
};
// 创建SVG组件
export const LiveManageBg = ({ className = '', ...props }: { className?: string; [key: string]: any }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.001 5.5H10.001C9.03141 5.5 8.671 5.50238 8.38517 5.53458C5.83526 5.82189 3.82287 7.83429 3.53556 10.3842C3.50335 10.67 3.50098 11.0304 3.50098 12C3.50098 12.9696 3.50335 13.33 3.53556 13.6158C3.82287 16.1657 5.83526 18.1781 8.38517 18.4654C8.671 18.4976 9.03141 18.5 10.001 18.5H14.001C14.9705 18.5 15.331 18.4976 15.6168 18.4654C18.1667 18.1781 20.1791 16.1657 20.4664 13.6158C20.4986 13.33 20.501 12.9696 20.501 12C20.501 11.0304 20.4986 10.67 20.4664 10.3842C20.1791 7.83429 18.1667 5.82189 15.6168 5.53458C15.331 5.50238 14.9705 5.5 14.001 5.5ZM2.04499 10.2162C2.00098 10.6069 2.00098 11.0713 2.00098 12C2.00098 12.9287 2.00098 13.3931 2.04499 13.7838C2.41065 17.0291 4.97189 19.5903 8.21723 19.956C8.60786 20 9.07224 20 10.001 20H14.001C14.9297 20 15.3941 20 15.7847 19.956C19.0301 19.5903 21.5913 17.0291 21.957 13.7838C22.001 13.3931 22.001 12.9287 22.001 12C22.001 11.0713 22.001 10.6069 21.957 10.2162C21.5913 6.97091 19.0301 4.40968 15.7847 4.04401C15.3941 4 14.9297 4 14.001 4H10.001C9.07224 4 8.60786 4 8.21723 4.04401C4.97189 4.40968 2.41065 6.97091 2.04499 10.2162ZM18.2717 8.99902H15.0205V15.0012H18.2717V13.752L16.1441 13.7518V12.5802L17.9582 12.5802V11.3736L16.1441 11.3734V10.2558L18.2717 10.256V8.99902ZM9.51758 8.99902H10.768V15.0012H9.51758V8.99902ZM7.14124 8.99902H6.01758V15.0012H9.26875V13.752L7.14118 13.7518L7.14124 8.99902ZM11.0176 8.99902H12.1319L12.8915 12.4455L13.6535 8.99902H14.7689L13.3078 15.0012H12.4783L11.0176 8.99902Z"
        fill="currentColor"
      />
    </svg>
  );
};

// TV Icon - 像素化电视图标
// TV Icon - 电视/直播图标（屏幕 + 顶部天线 + 三段信号条）
export const TvIcon = ({ className = '', ...props }: { className?: string; [key: string]: any }) => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
      <rect x="2" y="7" width="20" height="14" rx="2" stroke="currentColor" strokeWidth="1.5" fill="none" />
      <path d="M7 3L12 7L17 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8 17V14.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M12 17V11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M16 17V13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
};

// TV Active Icon - 激活态：屏幕实心，信号条镂空
export const TvActiveIcon = ({ className = '', ...props }: { className?: string; [key: string]: any }) => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
      <defs>
        <mask id="tv-active-mask">
          <rect width="24" height="24" fill="white" />
          <path d="M8 17V14.5" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
          <path d="M12 17V11" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
          <path d="M16 17V13" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
        </mask>
      </defs>
      <path d="M7 3L12 7L17 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <rect x="2" y="7" width="20" height="14" rx="2" fill="currentColor" stroke="currentColor" strokeWidth="1.5" mask="url(#tv-active-mask)" />
    </svg>
  );
};

export const KnowledgeIcon = ({ className = '', ...props }: { className?: string; [key: string]: any }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
      {/* Book/Document Outline */}
      <rect x="3" y="4" width="18" height="16" rx="2" ry="2" stroke="currentColor" strokeWidth="1.5" fill="none" />

      {/* Vertical Divider Line */}
      <line x1="12" y1="4" x2="12" y2="20" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />

      {/* Left Page Content - Text Lines */}
      <g stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
        {/* First line */}
        <line x1="5" y1="8" x2="10.5" y2="8" />
        {/* Second line */}
        <line x1="5" y1="10.5" x2="9" y2="10.5" />
        {/* Third line */}
        <line x1="5" y1="13" x2="10" y2="13" />
        {/* Fourth line */}
        <line x1="5" y1="15.5" x2="8.5" y2="15.5" />
      </g>

      {/* Right Page Content - Text Lines */}
      <g stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
        {/* First line */}
        <line x1="14" y1="8" x2="19.5" y2="8" />
        {/* Second line */}
        <line x1="14" y1="10.5" x2="18" y2="10.5" />
        {/* Third line */}
        <line x1="14" y1="13" x2="19" y2="13" />
        {/* Fourth line */}
        <line x1="14" y1="15.5" x2="17.5" y2="15.5" />
      </g>

      {/* Book Binding/Spine */}
      <rect x="2.5" y="4" width="1" height="16" fill="currentColor" />
    </svg>
  );
};

// Power/Energy Icon - 圆形闪电图标
export const PowerIcon = ({ className = '', ...props }: { className?: string; [key: string]: any }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
      {/* 圆形外框 */}
      <circle cx="12" cy="12" r="8" stroke="currentColor" strokeWidth="1.5" fill="none" />

      {/* 闪电符号 */}
      <path d="M12 6L9 12H12L11 18L15 12H12L13 6Z" fill="currentColor" />

      {/* 底部横线 */}
      <line x1="8" y1="23" x2="16" y2="23" r="0.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
};

export const LightIcon = ({ className = '', ...props }: { className?: string; [key: string]: any }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
      <path
        d="M15 7.33301H10.8L9 13.333H10.8L9 17.9997L15 11.333H12.6L15 7.33301Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M15.3333 2.56902C19.2173 3.94181 22 7.64594 22 12C22 17.5228 17.5228 22 12 22L14 19.5M8.66667 21.431C4.78269 20.0582 2 16.3541 2 12C2 6.47715 6.47715 2 12 2L10 4.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  );
};

// Trade Icon - 交易图标（圆环 + 上下弧形箭头表示交易流转）
export const TradeIcon = ({ className = '', ...props }: { className?: string; [key: string]: any }) => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5" />
      <path d="M10.59 10.59L12 9.17C12.78 8.39 14.05 8.39 14.83 9.17L20.49 14.83" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M13.41 13.41L12 14.83C11.22 15.61 9.95 15.61 9.17 14.83L3.51 9.17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
};

// Trade Active Icon - 激活态：圆环实心 + 箭头镂空
export const TradeActiveIcon = ({ className = '', ...props }: { className?: string; [key: string]: any }) => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
      <defs>
        <mask id="trade-active-mask">
          <rect width="24" height="24" fill="white" />
          <path d="M10.59 10.59L12 9.17C12.78 8.39 14.05 8.39 14.83 9.17L20.49 14.83" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
          <path d="M13.41 13.41L12 14.83C11.22 15.61 9.95 15.61 9.17 14.83L3.51 9.17" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
        </mask>
      </defs>
      <circle cx="12" cy="12" r="9" fill="currentColor" stroke="currentColor" strokeWidth="1.5" mask="url(#trade-active-mask)" />
    </svg>
  );
};
// Square Icon - 广场/发现图标（圆环 + 内部斜置音符卡片元素）
export const SquareIcon = ({ className = '', ...props }: { className?: string; [key: string]: any }) => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5" fill="none" />
      <path d="M14.5 8.5L9.5 11L8.5 16L13.5 13.5L14.5 8.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" fill="none" />
    </svg>
  );
};

// Square Active Icon - 激活态：实心圆 + 内部元素镂空
export const SquareActiveIcon = ({ className = '', ...props }: { className?: string; [key: string]: any }) => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
      <defs>
        <mask id="square-active-mask">
          <rect width="24" height="24" fill="white" />
          <path d="M14.5 8.5L9.5 11L8.5 16L13.5 13.5L14.5 8.5Z" stroke="black" strokeWidth="1.5" strokeLinejoin="round" fill="none" />
        </mask>
      </defs>
      <circle cx="12" cy="12" r="9" fill="currentColor" stroke="currentColor" strokeWidth="1.5" mask="url(#square-active-mask)" />
    </svg>
  );
};
export const InviteIcon = ({ className = '', ...props }: { className?: string; [key: string]: any }) => {
  return (
    <svg
      preserveAspectRatio="xMidYMid meet"
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      fill="none"
      viewBox="0 0 48 48"
      className={className}
      {...props}
    >
      <g>
        <path
          fill="#ff6800"
          d="M24.976 34.383c.953-.264 1.43-.397 1.82-.652a3.01 3.01 0 0 0 .867-.867c.256-.39.388-.867.653-1.82l.463-1.667c.325-1.17 1.983-1.17 2.307 0l.463 1.666c.265.954.397 1.43.653 1.82a3 3 0 0 0 .867.868c.39.255.867.388 1.82.652l1.667.463c1.169.325 1.169 1.983 0 2.308l-1.667.463c-.953.264-1.43.397-1.82.652a3 3 0 0 0-.867.867c-.256.39-.388.867-.653 1.82l-.463 1.667c-.324 1.17-1.982 1.17-2.307 0l-.463-1.666c-.265-.954-.397-1.43-.653-1.82a2.999 2.999 0 0 0-.867-.868c-.39-.255-.867-.388-1.82-.652l-1.666-.463c-1.17-.325-1.17-1.983 0-2.308l1.666-.463Zm9.983-11.075c.908-.253 1.363-.379 1.738-.617a3 3 0 0 0 .927-.927c.238-.375.364-.83.616-1.738.195-.701 1.19-.701 1.385 0 .252.909.378 1.363.617 1.738a3 3 0 0 0 .926.927c.376.238.83.364 1.739.617.701.195.701 1.19 0 1.384-.91.253-1.363.379-1.739.617a3 3 0 0 0-.926.927c-.239.375-.365.83-.617 1.738-.195.701-1.19.701-1.385 0-.252-.909-.378-1.363-.616-1.738a3 3 0 0 0-.927-.927c-.375-.238-.83-.364-1.738-.617-.702-.195-.702-1.19 0-1.384Z"
        />
        <path
          fill="currentColor"
          d="M22.433 4.5c5.799 0 10.5 4.701 10.5 10.5s-4.701 10.5-10.5 10.5c-7.824 0-14.25 5.991-14.939 13.635a1.5 1.5 0 0 1-2.988-.27c.639-7.089 5.387-12.992 11.843-15.31A10.484 10.484 0 0 1 11.933 15c0-5.799 4.701-10.5 10.5-10.5Zm0 3a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15Z"
        />
      </g>
    </svg>
  );
};

// Transfer Icon - 转账/转移图标（左右双向箭头）
export const TransferIcon = ({ className = '', ...props }: { className?: string; [key: string]: any }) => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
      <path d="M3 9H20" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M16 5L20 9L16 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M21 15H4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8 19L4 15L8 11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

// Market Icon - 行情图标（折线图表示市场趋势）
export const MarketIcon = ({ className = '', ...props }: { className?: string; [key: string]: any }) => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
      <path
        d="M19.5 3H4.5C3.67 3 3 3.67 3 4.5V19.5C3 20.33 3.67 21 4.5 21H19.5C20.33 21 21 20.33 21 19.5V4.5C21 3.67 20.33 3 19.5 3Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M7 14L11 10L13 13.5L17 9.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

// Market Active Icon - 激活状态的行情图标（实心背景，折线镂空）
export const MarketActiveIcon = ({ className = '', ...props }: { className?: string; [key: string]: any }) => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
      <defs>
        <mask id="market-active-mask">
          <rect width="24" height="24" fill="white" />
          <path d="M7 14L11 10L13 13.5L17 9.5" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </mask>
      </defs>
      <path
        d="M19.5 3H4.5C3.67 3 3 3.67 3 4.5V19.5C3 20.33 3.67 21 4.5 21H19.5C20.33 21 21 20.33 21 19.5V4.5C21 3.67 20.33 3 19.5 3Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        mask="url(#market-active-mask)"
      />
    </svg>
  );
};

// Scan Icon - 扫描图标（四角箭头表示扫描/识别）
export const ScanIcon = ({ className = '', ...props }: { className?: string; [key: string]: any }) => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
      <rect
        x="2.5" y="2.5" width="19" height="19" rx="1.5"
        fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
      />
      <path d="M17 10.5L18.5 12L17 13.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7 10.5L5.5 12L7 13.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M13.5 7L12 5.5L10.5 7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M13.5 17L12 18.5L10.5 17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

// Scan Active Icon - 激活状态的扫描图标（实心背景，四个箭头镂空）
export const ScanActiveIcon = ({ className = '', ...props }: { className?: string; [key: string]: any }) => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
      <defs>
        <mask id="scan-active-mask">
          <rect width="24" height="24" fill="white" />
          <path d="M17 10.5L18.5 12L17 13.5" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M7 10.5L5.5 12L7 13.5" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M13.5 7L12 5.5L10.5 7" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M13.5 17L12 18.5L10.5 17" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </mask>
      </defs>
      <rect
        x="2.5" y="2.5" width="19" height="19" rx="1.5"
        fill="currentColor" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
        mask="url(#scan-active-mask)"
      />
    </svg>
  );
};

// Swap Icon - 交换图标（上下箭头和连线表示交换）
export const SwapIcon = ({ className = '', ...props }: { className?: string; [key: string]: any }) => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
      <path
        d="M19.5 3H4.5C3.67 3 3 3.67 3 4.5V19.5C3 20.33 3.67 21 4.5 21H19.5C20.33 21 21 20.33 21 19.5V4.5C21 3.67 20.33 3 19.5 3Z"
        fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
      />
      <path d="M7.5 10.5L16.5 10.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7.5 13.5L16.5 13.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M16.5 10.5L13 7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M11 17L7.5 13.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

// Swap Active Icon - 激活状态的交换图标（实心背景，线条和箭头镂空）
export const SwapActiveIcon = ({ className = '', ...props }: { className?: string; [key: string]: any }) => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
      <defs>
        <mask id="swap-active-mask">
          <rect width="24" height="24" fill="white" />
          <path d="M7.5 10.5L16.5 10.5" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M7.5 13.5L16.5 13.5" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M16.5 10.5L13 7" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M11 17L7.5 13.5" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </mask>
      </defs>
      <path
        d="M19.5 3H4.5C3.67 3 3 3.67 3 4.5V19.5C3 20.33 3.67 21 4.5 21H19.5C20.33 21 21 20.33 21 19.5V4.5C21 3.67 20.33 3 19.5 3Z"
        fill="currentColor" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
        mask="url(#swap-active-mask)"
      />
    </svg>
  );
};

// Group Icon - 群聊图标（多个对话框和表情点）
export const GroupIcon = ({ className = '', ...props }: { className?: string; [key: string]: any }) => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
      <path d="M16.5 19H11V15H18V11H22V19H19.5L18 20.5L16.5 19Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M2 3H18V15H8.5L6.5 17L4.5 15H2V3Z" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9.5 9H10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M13 9H13.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M6 9H6.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
};

// Group Active Icon - 激活状态的群聊图标（实心背景，表情点镂空）
export const GroupActiveIcon = ({ className = '', ...props }: { className?: string; [key: string]: any }) => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
      <defs>
        <mask id="group-active-mask">
          <rect width="24" height="24" fill="white" />
          <path d="M9.5 9H10" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
          <path d="M13 9H13.5" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
          <path d="M6 9H6.5" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
        </mask>
      </defs>
      <path d="M16.5 19H11V15H18V11H22V19H19.5L18 20.5L16.5 19Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M2 3H18V15H8.5L6.5 17L4.5 15H2V3Z"
        fill="currentColor" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
        mask="url(#group-active-mask)"
      />
    </svg>
  );
};

// Live Center Icon - 直播中心图标（播放器和信号线）
export const LiveCenterIcon = ({ className = '', ...props }: { className?: string; [key: string]: any }) => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
      <path
        d="M2 5C2 4.45 2.45 4 3 4H17C17.55 4 18 4.45 18 5V9.5L22 6.5V18L18 15V19C18 19.55 17.55 20 17 20H3C2.45 20 2 19.55 2 19V5Z"
        fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
      />
      <path d="M5 8V10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7.5 7V11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10 8V10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

// Live Center Active Icon - 激活状态的直播中心图标（实心背景，信号线镂空）
export const LiveCenterActiveIcon = ({ className = '', ...props }: { className?: string; [key: string]: any }) => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
      <defs>
        <mask id="live-center-active-mask">
          <rect width="24" height="24" fill="white" />
          <path d="M5 8V10" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M7.5 7V11" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M10 8V10" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </mask>
      </defs>
      <path
        d="M2 5C2 4.45 2.45 4 3 4H17C17.55 4 18 4.45 18 5V9.5L22 6.5V18L18 15V19C18 19.55 17.55 20 17 20H3C2.45 20 2 19.55 2 19V5Z"
        fill="currentColor" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
        mask="url(#live-center-active-mask)"
      />
    </svg>
  );
};

// Invite Gift Icon - 邀请礼物图标（礼物盒和蝴蝶结）
export const InviteGiftIcon = ({ className = '', ...props }: { className?: string; [key: string]: any }) => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
      <path d="M20.5 22V10H3.5V22H20.5Z" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12 22V10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M20.5 22H3.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <rect x="2" y="6" width="20" height="4" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M8 2L12 6L16 2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

// Invite Gift Active Icon - 激活状态的邀请礼物图标（实心背景，中间分割线镂空）
export const InviteGiftActiveIcon = ({ className = '', ...props }: { className?: string; [key: string]: any }) => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
      <defs>
        <mask id="invite-gift-active-mask">
          <rect width="24" height="24" fill="white" />
          <path d="M12 22V10" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </mask>
      </defs>
      <path
        d="M20.5 22V10H3.5V22H20.5Z"
        fill="currentColor" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
        mask="url(#invite-gift-active-mask)"
      />
      <path d="M20.5 22H3.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <rect x="2" y="6" width="20" height="4" fill="currentColor" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M8 2L12 6L16 2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

// User Center Icon - 用户中心图标（头像和身体）
export const UserCenterIcon = ({ className = '', ...props }: { className?: string; [key: string]: any }) => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
      <circle cx="12" cy="6.5" r="4.5" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <path
        d="M2.5 22C2.5 17.78 5.59 13.84 8.2 13C8.2 13 10.58 15.53 12 17.22L15.8 13C17.94 13.28 21.5 17.78 21.5 22"
        stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"
      />
      <path d="M1 22L23 22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

// User Center Active Icon - 激活状态的用户中心图标（头部实心填充）
export const UserCenterActiveIcon = ({ className = '', ...props }: { className?: string; [key: string]: any }) => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
      <circle cx="12" cy="6.5" r="4.5" fill="currentColor" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <path
        d="M2.5 22C2.5 17.78 5.59 13.84 8.2 13C8.2 13 10.58 15.53 12 17.22L15.8 13C17.94 13.28 21.5 17.78 21.5 22"
        stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"
      />
      <path d="M1 22L23 22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const VipUserIcon = ({ className = '', ...props }: { className?: string; [key: string]: any }) => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
      <path d="M7 4L3.5 4L9 20H12L7 4Z" fill="currentColor" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M12 20L20.5 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const NormalUserIcon = ({ className = '', ...props }: { className?: string; [key: string]: any }) => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
      <path
        d="M2.25 8.18L6.26 3.84C6.45 3.62 6.74 3.5 7.04 3.5H16.96C17.26 3.5 17.55 3.62 17.74 3.84L21.75 8.18C22.09 8.55 22.08 9.11 21.73 9.47L12.37 20.07C12.18 20.30 11.83 20.30 11.63 20.07L2.27 9.47C1.92 9.11 1.91 8.55 2.25 8.18Z"
        fill="currentColor" strokeLinecap="round" strokeLinejoin="round"
      />
    </svg>
  );
};

export const WalletIcon = ({ className = '', ...props }: { className?: string; [key: string]: any }) => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
      <path d="M2 4H22V8C22 8 17 9 17 12C17 15 22 16 22 16V20H2V4Z" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M22 12H21" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const TwoFAIcon = ({ className = '', ...props }: { className?: string; [key: string]: any }) => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_112_5564)">
        <path
          d="M11 7V2.33333L6 1L1 2.33333V7.52543C1 8.05765 1.10277 8.59262 1.39709 9.03605C2.85576 11.2337 6 13 6 13"
          stroke="currentColor"
          strokeWidth="1.04"
          strokeLinecap="round"
        />
        <path
          d="M7.5233 9.088C7.7993 9.088 8.0273 9.168 8.2073 9.328C8.3833 9.488 8.4713 9.692 8.4713 9.948C8.4713 10.196 8.3753 10.42 8.1913 10.624C8.0793 10.744 7.8793 10.896 7.5993 11.084C7.3073 11.276 7.1313 11.444 7.0673 11.588H8.4753V12H6.4833C6.4833 11.708 6.5753 11.456 6.7673 11.24C6.8713 11.12 7.0913 10.944 7.4233 10.716C7.6073 10.588 7.7353 10.48 7.8153 10.396C7.9393 10.256 8.0033 10.104 8.0033 9.944C8.0033 9.788 7.9593 9.672 7.8793 9.596C7.7953 9.52 7.6713 9.484 7.5073 9.484C7.3313 9.484 7.1993 9.544 7.1113 9.664C7.0233 9.776 6.9753 9.948 6.9673 10.172H6.4993C6.5033 9.852 6.5953 9.596 6.7793 9.4C6.9673 9.192 7.2153 9.088 7.5233 9.088ZM8.95773 9.144H10.9057V9.544H9.42573V10.336H10.8217V10.736H9.42573V12H8.95773V9.144ZM12.0979 9.144H12.6299L13.7219 12H13.2219L12.9619 11.284H11.7659L11.5059 12H11.0059L12.0979 9.144ZM11.9059 10.9H12.8219L12.3739 9.648H12.3579L11.9059 10.9Z"
          fill="currentColor"
        />
        <path d="M4.3335 5.99967L6.00016 7.66634L8.3335 5.33301" stroke="currentColor" strokeWidth="1.04" strokeLinecap="round" stroke-linejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_112_5564">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const TwoFAActiveIcon = ({ className = '', ...props }: { className?: string; [key: string]: any }) => {
  return (
    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_112_6252)">
        <circle cx="40.0014" cy="39.9999" r="30.9091" fill="#33FF00" fill-opacity="0.1" />
        <path
          d="M40.0005 15.4541C53.5571 15.4542 64.5474 26.4443 64.5474 40.001C64.5473 53.5576 53.5571 64.5477 40.0005 64.5479C26.4438 64.5479 15.4537 53.5576 15.4536 40.001C15.4536 26.4442 26.4437 15.4541 40.0005 15.4541ZM29.729 29.1582C29.1571 29.2853 28.7505 29.7921 28.7505 30.3779V42.8613C28.7505 45.3688 30.0031 47.7105 32.0894 49.1016L40.0005 54.375L47.9106 49.1016C49.9969 47.7105 51.2505 45.3688 51.2505 42.8613V30.3779C51.2505 29.7921 50.843 29.2853 50.271 29.1582L40.0005 26.875L29.729 29.1582ZM48.7505 31.3809V42.8613C48.7505 44.5329 47.9147 46.0941 46.5239 47.0215L40.0005 51.3711L33.4761 47.0215C32.0853 46.0941 31.2505 44.5329 31.2505 42.8613V31.3809L40.0005 29.4365L48.7505 31.3809ZM40.0005 34.375C38.6198 34.375 37.5006 35.4944 37.5005 36.875C37.5005 37.8002 38.0025 38.6087 38.7495 39.041L38.7505 44.375H41.2505L41.2515 39.04C41.9979 38.6075 42.5005 37.7998 42.5005 36.875C42.5004 35.4946 41.3809 34.3753 40.0005 34.375Z"
          fill="#33FF00"
        />
      </g>
      <defs>
        <clipPath id="clip0_112_6252">
          <rect width="80" height="80" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ExportOutlinedIcon = ({ className = '', size, ...props }: { className?: string; size?: number | string; [key: string]: any }) => {
  const sizeVal = size != null ? (typeof size === 'number' ? `${size}px` : size) : '1em';
  return (
    <svg width={sizeVal} height={sizeVal} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
      <path d="M21 13.5C21 16.5 19 21.5 12 21.5C5 21.5 3 16.5 3 13.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12 2.5V16.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6 8.5L12 2.5L18 8.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

// 钱包logo
export const WalletActiveIcon = ({ className = '', ...props }: { className?: string; [key: string]: any }) => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
      <path
        d="M2 4H22V8C22 8 17 9 17 12C17 15 22 16 22 16V20H2V4Z"
        fill="currentColor" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"
      />
      <path d="M22 12H21" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

/** 预测图标 - 趋势图与问号（表示预测市场） */
export const PredictIcon = ({ className = '', ...props }: { className?: string; [key: string]: any }) => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" className={className} {...props}>
      <path d="M2 22H22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M2 13L6 14V19H2V13Z" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M10 12L14 10V19H10V12Z" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M18 8L22 6V19H18V8Z" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M2 9L6 10L22 2H17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

/** 预测图标（激活状态）- 三个柱状条填充 */
export const PredictActiveIcon = ({ className = '', ...props }: { className?: string; [key: string]: any }) => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" className={className} {...props}>
      <path d="M2 22H22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M2 13L6 14V19H2V13Z" fill="currentColor" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M10 12L14 10V19H10V12Z" fill="currentColor" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M18 8L22 6V19H18V8Z" fill="currentColor" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M2 9L6 10L22 2H17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

// 瀑布流 - 未激活状态
export const ExploreIcon = ({ className = '', ...props }: { className?: string; [key: string]: any }) => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
      <path
        d="M12 14.31C13.26 14.31 14.27 13.30 14.27 12.05C14.27 10.80 13.26 9.78 12 9.78C10.74 9.78 9.73 10.80 9.73 12.05C9.73 13.30 10.74 14.31 12 14.31Z"
        fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"
      />
      <path d="M8 7.5C5.33 10 5.33 14 8 16.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M16 16.5C18.67 14 18.67 10 16 7.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4.93 5C1.02 8.89 1.02 15.20 4.93 19.10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M19.07 19.10C22.98 15.20 22.98 8.89 19.07 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

// 瀑布流 - 激活状态
export const ExploreActiveIcon = ({ className = '', ...props }: { className?: string; [key: string]: any }) => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
      <path
        d="M12 14.31C13.26 14.31 14.27 13.30 14.27 12.05C14.27 10.80 13.26 9.78 12 9.78C10.74 9.78 9.73 10.80 9.73 12.05C9.73 13.30 10.74 14.31 12 14.31Z"
        fill="currentColor" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"
      />
      <path d="M8 7.5C5.33 10 5.33 14 8 16.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M16 16.5C18.67 14 18.67 10 16 7.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4.93 5C1.02 8.89 1.02 15.20 4.93 19.10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M19.07 19.10C22.98 15.20 22.98 8.89 19.07 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

// ios
// iOS / Apple 图标
// iOS / Apple 图标
// obs
export const OBSIcon = ({ className = '', ...props }: { className?: string; [key: string]: any }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 54 54" fill="none" className={className} {...props}>
      <rect x="5" y="6" width="44" height="32" rx="4" stroke="currentColor" strokeWidth="2" />
      <path
        d="M32.5 38L33.9216 44.0419C34.217 45.2973 33.2645 46.5 31.9748 46.5H22.0252C20.7355 46.5 19.783 45.2973 20.0784 44.0419L21.5 38"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M26.9999 26.9993C22.5334 26.9993 18.8999 23.3658 18.8999 18.8993C18.8999 14.4328 22.5334 10.7993 26.9999 10.7993C31.4664 10.7993 35.0999 14.4328 35.0999 18.8993C35.0999 23.3658 31.4664 26.9993 26.9999 26.9993ZM26.9999 11.5479C22.9465 11.5479 19.6492 14.8459 19.6492 18.8993C19.6492 22.9527 22.9465 26.2501 26.9999 26.2501C31.0533 26.2501 34.3507 22.9527 34.3507 18.8993C34.3507 14.8459 31.0533 11.5479 26.9999 11.5479ZM23.0728 14.8426C23.3104 13.6964 24.0873 12.663 25.1315 12.1453C24.9499 12.3295 24.7299 12.4713 24.5618 12.6718C23.8733 13.4143 23.5628 14.4889 23.7525 15.4771C23.9921 16.9857 25.4096 18.2176 26.9466 18.196C28.138 18.2493 29.299 17.5635 29.8815 16.5301C31.1289 16.5726 32.3419 17.2165 33.054 18.25C33.4185 18.7893 33.7033 19.4218 33.7229 20.0799C33.4921 19.2058 32.9116 18.4288 32.1198 17.9908C31.7359 17.7757 31.3129 17.6396 30.8757 17.5903C30.4385 17.541 29.9958 17.5797 29.5737 17.7039C28.5207 18.0063 27.6506 18.8669 27.3509 19.9267C27.0964 20.7704 27.2051 21.7006 27.6054 22.4728C27.0485 23.4373 26.0428 24.1258 24.9513 24.3331C24.1116 24.5092 23.2294 24.3729 22.4477 24.0199C23.147 24.2237 23.9064 24.2595 24.6016 24.0124C25.0675 23.8543 25.4924 23.5945 25.8454 23.2518C26.1985 22.9092 26.4709 22.4923 26.6428 22.0313C27.0181 21.0256 26.8757 19.8301 26.2439 18.9668C25.7714 18.2871 25.0269 17.8078 24.2176 17.6377C23.9611 17.5918 23.7019 17.5716 23.4427 17.5473C23.0302 16.7164 22.8797 15.7518 23.0863 14.85L23.0728 14.8426Z"
        fill="currentColor"
        stroke="#33FF00"
        strokeWidth="0.5"
        strokeLinejoin="round"
      />
      <path d="M49 32H5" stroke="currentColor" strokeWidth="2" />
    </svg>
  );
};

// webrtc
export const WebRTCIcon = ({ className = '', ...props }: { className?: string; [key: string]: any }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 54 54" fill="none" className={className} {...props}>
      <path
        d="M5 43V23.5C5 21.2909 6.79086 19.5 9 19.5H17C19.2091 19.5 21 21.2909 21 23.5V43C21 45.2091 19.2091 47 17 47H9C6.79086 47 5 45.2091 5 43Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path d="M9 40H17" stroke="#33FF00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M8.5 15V11.5C8.5 9.29086 10.2909 7.5 12.5 7.5H45C47.2091 7.5 49 9.29086 49 11.5V28.5M26 38H33M33 38H45C47.2091 38 49 36.2091 49 34V28.5M33 38V47M33 47H39H26H33ZM49 28.5H26"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.8513 13.0506L33.6698 13.0469L33.483 13.0521C32.6157 13.1016 31.7939 13.4565 31.1633 14.0541L26.3738 19.0356C25.8158 19.6551 25.0463 19.9971 24.2288 19.9679C22.7775 19.9169 21.585 18.6891 21.51 17.1591C21.4275 15.4566 22.7175 14.0361 24.3255 14.0361C24.9975 14.0361 25.6343 14.2881 26.1405 14.7359L26.298 14.8836L27.3698 16.0041C27.4589 16.0939 27.58 16.1446 27.7065 16.1451C27.771 16.145 27.8347 16.1317 27.8939 16.1062C27.953 16.0806 28.0064 16.0434 28.0508 15.9966C28.1375 15.9052 28.1867 15.7845 28.1887 15.6585C28.1906 15.5326 28.1451 15.4104 28.0613 15.3164L26.82 14.0189L26.811 14.0271L26.6948 13.9244C25.9823 13.3146 25.0625 13.0023 24.126 13.0521C22.1813 13.1571 20.6228 14.8146 20.5478 16.8471C20.4653 19.0911 22.1828 20.9594 24.3263 20.9594C25.308 20.9594 26.2313 20.5619 26.9288 19.8681L31.842 14.7554C32.3417 14.2946 32.9961 14.0379 33.6758 14.0361C35.2283 14.0361 36.495 15.3651 36.495 17.0031C36.495 18.6411 35.2275 19.9701 33.6758 19.9701C32.9498 19.9701 32.2658 19.6761 31.7438 19.1571L30.6308 18.0096C30.5861 17.9646 30.5328 17.929 30.4741 17.9049C30.4154 17.8808 30.3525 17.8688 30.2891 17.8695C30.2256 17.8702 30.163 17.8836 30.1048 17.909C30.0467 17.9343 29.9942 17.9711 29.9505 18.0171C29.8635 18.1081 29.8139 18.2285 29.8116 18.3544C29.8092 18.4803 29.8543 18.6024 29.9378 18.6966L31.0643 19.8576C31.767 20.5604 32.6918 20.9594 33.6758 20.9594C35.817 20.9594 37.5345 19.0934 37.4543 16.8524L37.4445 16.6784C37.296 14.7749 35.8448 13.2381 34.0185 13.0634L33.852 13.0514L33.8513 13.0506Z"
        fill="currentColor"
        stroke="#33FF00"
        strokeWidth="0.2"
      />
    </svg>
  );
};

export const MessageListIcon = ({ className = '', ...props }: { className?: string; [key: string]: any }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" className={className} {...props}>
      <g clip-path="url(#clip0_3_2035)">
        <path
          d="M8.66406 4.30859C9.60623 4.30859 10.5268 4.39473 11.4082 4.49316C12.7875 4.65209 13.8744 5.7423 14.0293 7.12207C14.0303 7.13115 14.0303 7.14033 14.0312 7.14941C14.4021 6.94223 14.7781 6.74371 15.1367 6.55469C15.9406 6.13086 16.7979 6.3502 16.876 7.24316C16.877 7.25317 17.0127 8.58646 17.0127 9.84863C17.0127 11.1025 16.8787 12.4269 16.876 12.4541C16.7979 13.3419 15.9394 13.5673 15.1367 13.1436C14.7784 12.9545 14.4029 12.753 14.0322 12.543C14.0311 12.5536 14.0304 12.5646 14.0293 12.5752C13.8741 13.9546 12.7873 15.0452 11.4082 15.2041C10.5268 15.3025 9.6062 15.3887 8.66406 15.3887C7.72213 15.3887 6.80212 15.3025 5.9209 15.2041C4.54168 15.0453 3.45402 13.9547 3.29883 12.5752C3.20452 11.6981 3.12407 10.7841 3.12402 9.84863C3.12402 8.91317 3.20453 7.99917 3.29883 7.12207C3.45371 5.74223 4.54147 4.65201 5.9209 4.49316C6.80215 4.39475 7.7221 4.30861 8.66406 4.30859ZM8.39355 7.78027C7.88994 7.51435 7.37257 7.65044 7.30273 8.2832C7.29993 8.29545 7.2334 8.59955 7.2334 9.84766C7.23341 11.1223 7.30273 11.4121 7.30273 11.4121C7.37262 11.9825 7.88921 12.1806 8.39355 11.915C9.04423 11.5721 9.78613 11.1773 10.2803 10.7529C10.6176 10.4632 10.8396 10.2292 10.8398 9.84766C10.8398 9.48865 10.6187 9.24785 10.2822 8.95703C9.78772 8.52951 9.04471 8.12382 8.39355 7.78027Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_3_2035">
          <rect width="20" height="20" rx="4" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const RulesIcon = ({ className = '', ...props }: { className?: string; [key: string]: any }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" className={className} {...props}>
      <path
        d="M17.3718 1.46484H6.6263C5.39822 1.46518 4.22048 1.95292 3.35173 2.82095C2.48299 3.68897 1.99428 4.8663 1.99292 6.09438V18.1486C1.99326 19.3773 2.48153 20.5556 3.35038 21.4245C4.21923 22.2934 5.39755 22.7816 6.6263 22.782H17.3718C18.5991 22.7806 19.7758 22.2924 20.6435 21.4244C21.5112 20.5565 21.9991 19.3797 22.0001 18.1524V6.09438C21.9991 4.86709 21.5112 3.69033 20.6435 2.82238C19.7758 1.95443 18.5991 1.4662 17.3718 1.46484ZM20.465 18.1486C20.4654 18.9695 20.1397 19.757 19.5597 20.338C18.9797 20.9189 18.1928 21.2459 17.3718 21.2469H6.6263C5.80591 21.2459 5.01941 20.9195 4.4393 20.3394C3.8592 19.7593 3.53285 18.9728 3.53184 18.1524V6.09438C3.53285 5.27399 3.8592 4.48749 4.4393 3.90739C5.01941 3.32729 5.80591 3.00094 6.6263 2.99992H17.3718C18.1921 3.00094 18.9785 3.32733 19.5584 3.90747C20.1383 4.48761 20.4643 5.27411 20.465 6.09438V18.1486Z"
        fill="currentColor"
      />
      <path
        d="M17.712 6.52539H10.0801C9.87654 6.52539 9.68131 6.60626 9.53737 6.7502C9.39343 6.89414 9.31256 7.08937 9.31256 7.29293C9.31256 7.49649 9.39343 7.69172 9.53737 7.83566C9.68131 7.9796 9.87654 8.06047 10.0801 8.06047H17.712C17.9156 8.06047 18.1108 7.9796 18.2547 7.83566C18.3987 7.69172 18.4795 7.49649 18.4795 7.29293C18.4795 7.08937 18.3987 6.89414 18.2547 6.7502C18.1108 6.60626 17.9156 6.52539 17.712 6.52539ZM6.2795 8.06047H7.21078C7.41435 8.06047 7.60957 7.9796 7.75351 7.83566C7.89746 7.69172 7.97832 7.49649 7.97832 7.29293C7.97832 7.08937 7.89746 6.89414 7.75351 6.7502C7.60957 6.60626 7.41435 6.52539 7.21078 6.52539H6.2795C6.07594 6.52539 5.88071 6.60626 5.73677 6.7502C5.59283 6.89414 5.51196 7.08937 5.51196 7.29293C5.51196 7.49649 5.59283 7.69172 5.73677 7.83566C5.88071 7.9796 6.07594 8.06047 6.2795 8.06047ZM17.712 16.4944H10.0801C9.87654 16.4944 9.68131 16.5753 9.53737 16.7193C9.39343 16.8632 9.31256 17.0584 9.31256 17.262C9.31256 17.4655 9.39343 17.6608 9.53737 17.8047C9.68131 17.9487 9.87654 18.0295 10.0801 18.0295H17.712C17.9156 18.0295 18.1108 17.9487 18.2547 17.8047C18.3987 17.6608 18.4795 17.4655 18.4795 17.262C18.4795 17.0584 18.3987 16.8632 18.2547 16.7193C18.1108 16.5753 17.9156 16.4944 17.712 16.4944ZM7.21078 16.4944H6.2795C6.17871 16.4944 6.0789 16.5143 5.98578 16.5529C5.89266 16.5914 5.80804 16.648 5.73677 16.7193C5.6655 16.7905 5.60896 16.8751 5.57039 16.9683C5.53182 17.0614 5.51196 17.1612 5.51196 17.262C5.51196 17.3628 5.53182 17.4626 5.57039 17.5557C5.60896 17.6488 5.6655 17.7334 5.73677 17.8047C5.80804 17.876 5.89266 17.9325 5.98578 17.9711C6.0789 18.0097 6.17871 18.0295 6.2795 18.0295H7.21078C7.41435 18.0295 7.60957 17.9487 7.75351 17.8047C7.89746 17.6608 7.97832 17.4655 7.97832 17.262C7.97832 17.0584 7.89746 16.8632 7.75351 16.7193C7.60957 16.5753 7.41435 16.4944 7.21078 16.4944ZM6.2795 13.0444H13.9178C14.1214 13.0444 14.3166 12.9635 14.4605 12.8195C14.6045 12.6756 14.6853 12.4804 14.6853 12.2768C14.6853 12.0733 14.6045 11.878 14.4605 11.7341C14.3166 11.5901 14.1214 11.5093 13.9178 11.5093H6.2795C6.07594 11.5093 5.88071 11.5901 5.73677 11.7341C5.59283 11.878 5.51196 12.0733 5.51196 12.2768C5.51196 12.4804 5.59283 12.6756 5.73677 12.8195C5.88071 12.9635 6.07594 13.0444 6.2795 13.0444ZM17.712 11.5093H16.7807C16.5772 11.5093 16.3819 11.5901 16.238 11.7341C16.094 11.878 16.0132 12.0733 16.0132 12.2768C16.0132 12.4804 16.094 12.6756 16.238 12.8195C16.3819 12.9635 16.5772 13.0444 16.7807 13.0444H17.712C17.9156 13.0444 18.1108 12.9635 18.2547 12.8195C18.3987 12.6756 18.4795 12.4804 18.4795 12.2768C18.4795 12.0733 18.3987 11.878 18.2547 11.7341C18.1108 11.5901 17.9156 11.5093 17.712 11.5093Z"
        fill="currentColor"
      />
    </svg>
  );
};


// 弹幕图标 - 屏幕 + 滚动文字行 + 右下设置六边形
export const DanMuIcon = ({
  className = '',
  size,
  ...props
}: {
  className?: string;
  size?: number | string;
  [key: string]: any;
}) => {
  const sizeVal = size != null ? (typeof size === 'number' ? `${size}px` : size) : '1em';
  return (
    <svg width={sizeVal} height={sizeVal} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
      <path
        d="M3 5C3 4.45 3.45 4 4 4H20C20.55 4 21 4.45 21 5V12H19V6H5V18H13V20H4C3.45 20 3 19.55 3 19V5Z"
        fill="currentColor"
      />
      <rect x="7" y="8.5" width="9" height="1.5" rx="0.5" fill="currentColor" />
      <rect x="7" y="12" width="6.5" height="1.5" rx="0.5" fill="currentColor" />
      {/* 右下角齿轮：使用主题主色（绿色），不跟随父级 currentColor */}
      <g transform="translate(-1, -2) scale(1.35)" style={{ transformOrigin: '20.29px 19.86px' }}>
        <path fillRule="evenodd" clipRule="evenodd" d="M20.78 16.703a1 1 0 0 0-.981 0l-2.429 1.366a1 1 0 0 0-.51.872v2.687a1 1 0 0 0 .51.872l2.429 1.366a1 1 0 0 0 .98 0l2.429-1.366a1 1 0 0 0 .51-.872v-2.687a1 1 0 0 0-.51-.872l-2.429-1.366zm-.49 2.299a1.286 1.286 0 1 0-.001 2.572 1.286 1.286 0 0 0 0-2.572z" fill="rgb(var(--green-color))"/>
      </g>
    </svg>
  );
};

export const DanMuCloseIcon = ({
  className = '',
  size,
  ...props
}: {
  className?: string;
  size?: number | string;
  [key: string]: any;
}) => {
  const sizeVal = size != null ? (typeof size === 'number' ? `${size}px` : size) : '1em';
  return (
    <svg width={sizeVal} height={sizeVal} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
      <path
        d="M3 5C3 4.45 3.45 4 4 4H20C20.55 4 21 4.45 21 5V12H19V6H5V18H13V20H4C3.45 20 3 19.55 3 19V5Z"
        fill="currentColor"
        fillOpacity="0.75"
      />
      <rect x="7" y="8.5" width="9" height="1.5" rx="0.5" fill="currentColor" fillOpacity="0.75" />
      <rect x="7" y="12" width="6.5" height="1.5" rx="0.5" fill="currentColor" fillOpacity="0.75" />
      {/* 右下角禁止符号（红色） */}
      <circle cx="19" cy="19" r="4" stroke="#ef4444" strokeWidth="1.6" fill="none" />
      <line x1="16.2" y1="21.8" x2="21.8" y2="16.2" stroke="#ef4444" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  );
};

// 字幕配置
export const ZiMuIcon = ({
  className = '',
  size = 24,
  ...props
}: {
  className?: string;
  size?: number;
  [key: string]: any;
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M21.2 3.01L21 3H3l-.21.01c-.49.05-.95.28-1.28.64C1.18 4.02.99 4.5 1 5v14l.01.2c.04.46.25.88.57 1.21.33.32.75.53 1.21.58L3 21h18l.2-.02c.46-.04.88-.25 1.21-.57.32-.33.53-.75.58-1.21L23 19V5c0-.5-.19-.98-.52-1.35-.33-.36-.79-.59-1.28-.64ZM3 19V5h18v14H3Z"
        fill="currentColor"
      />
      <path
        d="M8 11H6a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2ZM18 11h-6a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2ZM18 15h-2a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2ZM12 15H6a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2Z"
        fill="currentColor"
      />
    </svg>
  );
};